import {gsap, SplitText, ScrollTrigger} from "../LibrariesImport";
import LoadScript from "../utils/LoadScript";
export default class CtaShortcut {
	static init() {

		this.cta = document.querySelector('.cta-shortcut');
		this.footer = document.querySelector('.footer-main');

		if( !this.cta || !this.footer ){
			return;
		}

		ScrollTrigger.create({
			trigger: ".banner",
			start: "bottom bottom",
			endTrigger: this.footer,
			end: "top bottom",
			toggleClass: {
				targets: this.cta, className: "enable"
			}
		});

		let btnFindAgency = this.cta.querySelector('.btn-search');
		if( btnFindAgency ) {
			btnFindAgency.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.toggle('find-agency-opened');
				
			});
		}
		
		let formFindMyAgency = document.querySelectorAll('.find-my-agency');
		formFindMyAgency.forEach( (form) => {
			this.initInput(form);
		});

		let btnRdvAgency = this.cta.querySelector('.btn-rdv');
		if( btnRdvAgency ) {
			btnRdvAgency.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.toggle('rdv-form-opened');
			});
			let btnRdvAgencyClose = document.querySelector('.agency-form .close');
			btnRdvAgencyClose.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('rdv-form-opened');
			});
		}

		let overlayFindAgency = document.querySelector('.cta-shortcut-overlay');
		overlayFindAgency.addEventListener('click', (e) => {
			e.preventDefault();
			document.body.classList.remove('find-agency-opened');
			document.body.classList.remove('rdv-form-opened');
		});

	}

	static initInput(form){
		const input = form.querySelector("input[name='location']");
		const coordinate = form.querySelector("input[name='coordinate']");

		input.addEventListener("focus", () => {
			LoadScript.load("https://maps.googleapis.com/maps/api/js?key=" + mcArgs.gmapApiKey + "&callback=Function.prototype&libraries=marker,places", () => {
				const options = {
					componentRestrictions: {country: 'fr'}
				};
				const searchBox = new google.maps.places.Autocomplete(input, options);
				searchBox.addListener("place_changed", (e) => {
					const places = searchBox.getPlace();
					if (places.length === 0) {
						return;
					}
					coordinate.value = places.geometry.location.lat() + ',' + places.geometry.location.lng();
				});
			});
		});
	}

}